import TedTheme from '@common/providers/ThemeProvider/TedTheme';
import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function EmailSent() {
  const { t } = useTranslation();
  return (
    <TedTheme>
      <Box sx={{ p: 2 }}>
        <Alert severity='success'>{t('mail_sent')}</Alert>
      </Box>
    </TedTheme>
  );
}
